import { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { BodyCopy } from "../../components/BodyCopy";
import { AuraLayout, Layout } from "lola-framework-ui-test";
import { useStore } from "../../store/globalState";
import { useSessionStore } from "../../store/useSessionStore";

/**
 * Starter entry splash. In the production widget this claims the magic link
 * and auto-routes after 2s; in the gallery it is a static, inspectable
 * splash: sponsored / PATRIOT-Act chrome stay mounted; center is logo or spinner.
 */
export const LoadingPage = memo(() => {
  const { t } = useTranslation("starter");
  const { session } = useSessionStore();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;

  const logoSrc = session.data?.partner?.logoUrl;
  const partnerName = session.data?.partner?.name ?? "Partner logo";

  return (
    <AuraLayout colorConfig={colorConfig}>
      <Layout.Header>
        <BodyCopy className="footer-text">
          <label className="muted-foreground" style={{ color: "#787878" }}>
            <Trans i18nKey="loader.sponsored" ns="starter" />
          </label>
        </BodyCopy>
      </Layout.Header>

      <Layout.Content>
        <div className="landing-section content-center loader-page splash-screen">
          {logoSrc ? (
            <img src={logoSrc} alt={partnerName} className="partner-logo-splash" />
          ) : (
            <section className="content">
              <div
                className="loader-spinner"
                role="status"
                aria-label="Loading"
              />
            </section>
          )}
        </div>
      </Layout.Content>

      <Layout.Footer>
        <label className="muted-foreground patriot-text" style={{ color: "#787878" }}>
          {(() => {
            const patriotAct = t("loader.patriotAct");
            const colon = patriotAct.indexOf(":");
            if (colon < 0) return patriotAct;
            return (
              <>
                <strong>{patriotAct.slice(0, colon + 1)}</strong>
                {patriotAct.slice(colon + 1)}
              </>
            );
          })()}
        </label>
      </Layout.Footer>
    </AuraLayout>
  );
});
